import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ProductEligibility from './components/ProductEligibility';

const ProductEligibilityPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Product Eligibility Report</h3>
      </Col>
    </Row>
    <Row>
      <ProductEligibility />
    </Row>
  </Container>
);

export default ProductEligibilityPage;
